import type { Role, Strana } from '@/types/api';

// Mapovani role -> strana. Drzime ho na FE, aby UI nemuselo strana nikde
// ukazovat — derivuje se z role v payload helperu (mapFormToInput).
// Backend pres ASP.NET extension Role.GetStrana() ma stejny mapping; oba
// pohledy musi byt v synchronizaci (Domain/Enums/Role.cs).
const ROLE_TO_STRANA: Record<Role, Strana> = {
  ADMIN: 'NASE_FIRMA',
  SCHVALOVATEL: 'NASE_FIRMA',
  TECHNIK_INT: 'NASE_FIRMA',
  VEDOUCI: 'EXTERNI_FIRMA',
  TECHNIK_EXT: 'EXTERNI_FIRMA',
};

export function stranaForRole(role: Role): Strana {
  return ROLE_TO_STRANA[role];
}

/**
 * Strana odvozená z výběru více rolí. Uživatel může mít víc rolí (typicky
 * ADMIN + SCHVALOVATEL), ale jen v rámci jedné strany — mix nebo prázdný
 * výběr vrací null (formulář nedovolí uložit, backend to samé odmítne 400).
 */
export function stranaForRoles(roles: Role[]): Strana | null {
  if (roles.length === 0) return null;
  const strany = new Set(roles.map((r) => ROLE_TO_STRANA[r]));
  return strany.size === 1 ? stranaForRole(roles[0]) : null;
}

/** Lidsky-citelny popisek role pro UI (Czech). */
export const ROLE_LABELS: Record<Role, string> = {
  ADMIN: 'Administrátor',
  SCHVALOVATEL: 'Schvalovatel (Green Gas DPB)',
  TECHNIK_INT: 'Technik (Green Gas DPB)',
  VEDOUCI: 'Vedoucí (externí firma)',
  TECHNIK_EXT: 'Technik (externí firma)',
};

export const ALL_ROLES: Role[] = [
  'ADMIN',
  'SCHVALOVATEL',
  'TECHNIK_INT',
  'VEDOUCI',
  'TECHNIK_EXT',
];
